import React, { useMemo } from "react";
import { Tooltip, Typography } from "@mui/material";

import { objectToFormData } from "../../../../utils";
import AdminLogo from "../../../../styles/svg/admin.svg";
import UserLogo from "../../../../styles/svg/not-owner.svg";
import { TooltipName } from "../../../../utils/Enums";
import FormDialog from "../../../../components/Dialog/FormDialog";
import { currentUserId } from "../../../../utils/constants";
import { useUserMutationDialog } from "../hooks/useUserMutationDialog";
import { getAdminDialogContent } from "../utils/userManagementUtils";

const Admin = ({ isSuperAdmin, userId }) => {
  const currentUser = currentUserId();
  const isCurrentUser = String(currentUser) === String(userId);
  const adminDialog = useUserMutationDialog({
    userId,
    initialValue: isSuperAdmin,
    createPayload: (role) =>
      objectToFormData({
        role: role === "Super Admin" ? "User" : "Super Admin",
      }),
    getNextValue: (role) => (role === "Super Admin" ? "User" : "Super Admin"),
  });
  const dialogContent = useMemo(
    () => getAdminDialogContent(adminDialog.value),
    [adminDialog.value]
  );

  return (
    <>
      {adminDialog.isDialogOpen && (
        <FormDialog
          open={adminDialog.isDialogOpen}
          handleClose={adminDialog.closeDialog}
          handleSubmit={adminDialog.submit}
          isLoading={adminDialog.isSubmitting}
          alignActions={"center"}
          buttonTxt={dialogContent.buttonText}
          title={dialogContent.title}
          cancelBtn={true}
          fullWidth={true}
        >
          <Typography className="align_text_center mb-2">
            {dialogContent.message}
          </Typography>
        </FormDialog>
      )}
      {adminDialog.value == "Super Admin" ? (
        <Tooltip title={TooltipName.MANAGE_USER.REVOKE_ADMIN_RIGHTS}>
          <img
            src={AdminLogo}
            onClick={!isCurrentUser ? adminDialog.openDialog : () => {}}
            style={{
              cursor: isCurrentUser ? "not-allowed" : "pointer",
              opacity: isCurrentUser ? 0.6 : 1,
            }}
            alt="admin"
          />
        </Tooltip>
      ) : (
        <Tooltip title={TooltipName.MANAGE_USER.GRANT_ADMIN_RIGHTS}>
          <img
            src={UserLogo}
            onClick={!isCurrentUser ? adminDialog.openDialog : () => {}}
            style={{
              cursor: isCurrentUser ? "not-allowed" : "pointer",
              opacity: isCurrentUser ? 0.6 : 1,
            }}
            alt="admin"
          />
        </Tooltip>
      )}
    </>
  );
};

const isChangeAdmin = (prevProps, nextProps) => {
  return (
    prevProps?.isSuperAdmin === nextProps?.isSuperAdmin
    && prevProps?.userId === nextProps?.userId
  );
};

export default React.memo(Admin, isChangeAdmin);
